const ShareButton = () => import('./ShareButton')
const ShareNetworks = () => import('./ShareNetworks')

export default function installComponents(Vue) {
  Vue.component('ShareButton', ShareButton)
  Vue.component('ShareNetworks', ShareNetworks)
}
